import { createContext } from 'react';

export const scopeContext = createContext<string | undefined>(undefined);
